import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Lenis from "lenis";
import { UIProvider } from "./context/UIContext";
import Home from "./pages/Home";
import Legal from "./pages/Legal";
import Admin from "./pages/Admin";

function useLenis() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.085, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = undefined; };
  }, []);
}

function App() {
  useLenis();
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <UIProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<Legal kind="privacy" />} />
            <Route path="/terms" element={<Legal kind="terms" />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </UIProvider>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
